import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const useHandleModalPath = (targetPathname, redirectPathname, onOpenModal, modalView) => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname === targetPathname) {
      navigate(redirectPathname);
      onOpenModal(modalView);
    }
  }, [location.pathname, targetPathname, redirectPathname, onOpenModal, modalView, navigate]);
};

export default useHandleModalPath;
